import { makeStyles } from 'lib/components';

export default makeStyles((theme) => ({
  pageContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    padding: '16px 24px',
    gap: '24px',
    backgroundColor: theme.evPalette.charcoal[100],
    '@media (max-width: 640px)': {
      padding: '0px',
    },
  },
  mainPaper: {
    display: 'flex',
    flexDirection: 'column',
    padding: '16px 24px',
    backgroundColor: theme.evPalette.salt[100],
    borderRadius: '4px',
    gap: '24px',
    '@media (max-width: 640px)': {
      padding: '12px',
      gap: '16px',
    },
  },
  tabsContainer: {
    border: `1px solid ${theme.evPalette.charcoal[400]}`,
    borderRadius: '4px',
    width: '100%',
    alignItems: 'flex-start',
    '& .myev-MuiTabs-indicator': {
      backgroundColor: '#0076AD !important',
    },
    '@media (max-width: 640px)': {
      borderRadius: '8px',
      overflow: 'hidden',
      '& .myev-MuiTabs-flexContainer': {
        flexDirection: 'column',
      },
      '& .myev-MuiTabs-indicator': {
        display: 'none',
      },
    },
  },
  tab: {
    textTransform: 'uppercase',
    fontSize: '10px',
    fontWeight: 600,
    color: theme.evPalette.charcoal[900],
    flex: 1,
    minWidth: 0,
    maxWidth: 'none',
    padding: '12px 16px',
    '&:not(:last-child)': {
      borderRight: `1px solid ${theme.evPalette.charcoal[400]}`,
    },
    '&.Mui-selected': {
      backgroundColor: theme.evPalette.ocean[100],
    },
    '& > .myev-MuiTab-wrapper': {
      alignItems: 'flex-start',
    },
    '@media (max-width: 640px)': {
      padding: '16px',
      minWidth: 'unset',
      maxWidth: '100%',
      width: '100%',
      border: 'none',
      borderRadius: '0',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      borderBottom: `1px solid ${theme.evPalette.charcoal[400]}`,
      '&:not(:last-child)': {
        borderRight: 'none',
      },
      '&:last-child': {
        borderBottom: 'none',
      },
      '&.Mui-selected': {
        borderBottom: '4px solid #0076AD',
        paddingBottom: '13px',
      },
      '&.Mui-selected:not(:last-child)': {
        borderBottom: '1px solid #0076AD',
      },
      '& > .myev-MuiTab-wrapper': {
        alignItems: 'flex-start',
        textAlign: 'left',
        width: '100%',
      },
    },
  },
  subscriptionInfoContainer: {
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: theme.evPalette.salt[100],
    borderRadius: '4px',
    gap: '16px',
    alignItems: 'stretch',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    '@media (max-width: 640px)': {
      gap: '12px',
      alignItems: 'flex-start',
    },
  },
  filterContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    marginLeft: 'auto',
    flexShrink: 0,
    '& .myev-MuiSelect-root': {
      backgroundColor: theme.evPalette.salt[100],
      border: `1px solid ${theme.evPalette.charcoal[400]}`,
      borderRadius: '4px',
      padding: '0px 12px',
      minWidth: '150px',
      height: '44px',
      fontSize: '14px',
      fontWeight: 400,
      color: theme.evPalette.charcoal[900],
      display: 'flex',
      alignItems: 'center',
      '&:hover': {
        borderColor: theme.evPalette.charcoal[600],
      },
      '&:focus': {
        borderColor: theme.evPalette.ocean[600],
        backgroundColor: theme.evPalette.salt[100],
      },
      '& .myev-MuiSelect-select': {
        padding: '0',
        paddingRight: '24px',
        height: 'auto',
        lineHeight: '1.5',
      },
    },
    '& .myev-MuiSelect-icon': {
      color: theme.evPalette.charcoal[700],
      right: '8px',
    },
    '@media (max-width: 640px)': {
      marginLeft: '0',
      width: '100%',
      flexBasis: '100%',
      order: 3,
      '& .myev-MuiSelect-root': {
        width: '100%',
        minWidth: 'unset',
      },
      '& .myev-MuiFormControl-root': {
        width: '100%',
      },
      '& > div': {
        width: '100%',
      },
    },
  },
  subscriptionContentWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    flex: 1,
    '@media (max-width: 640px)': {
      gap: '8px',
      minWidth: 0,
      order: 2,
    },
  },
  subscriptionHeader: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  subscriptionTitle: {
    fontSize: '24px',
    fontWeight: 600,
    color: theme.evPalette.charcoal[900],
    '@media (max-width: 640px)': {
      fontSize: '18px',
    },
  },
  subscriptionDetails: {
    display: 'flex',
    flexDirection: 'row',
    gap: '48px',
    alignItems: 'flex-start',
    flexWrap: 'wrap',
    '@media (max-width: 640px)': {
      flexDirection: 'column',
      gap: '8px',
    },
  },
  subscriptionLeftColumn: {
    display: 'flex',
    flexDirection: 'column',
    '@media (max-width: 640px)': {
      width: '100%',
    },
  },
  subscriptionRightColumn: {
    display: 'flex',
    flexDirection: 'column',
    padding: '4px',
    '@media (max-width: 640px)': {
      width: '100%',
      padding: '0px',
      minWidth: 0,
      overflow: 'hidden',
    },
  },
  subscriptionDetailItem: {
    display: 'flex',
    flexDirection: 'column',
  },
  subscriptionDetailsTable: {
    backgroundColor: theme.evPalette.salt[100],
    '& .myev-MuiTableCell-root': {
      border: 'none',
      padding: '0px 48px 4px 0px',
    },
    '@media (max-width: 640px)': {
      width: '100%',
      tableLayout: 'fixed',
      '& .myev-MuiTableCell-root': {
        padding: '2px',
        fontSize: '11px',
        verticalAlign: 'top',
      },
      '& .myev-MuiTableCell-root:first-child': {
        width: '65%',
      },
      '& .myev-MuiTableCell-root:last-child': {
        width: '35%',
      },
    },
  },
  subscriptionDetailLabel: {
    fontSize: '12px',
    fontWeight: 400,
    color: theme.evPalette.charcoal[700],
    whiteSpace: 'nowrap',
    '@media (max-width: 640px)': {
      whiteSpace: 'normal',
      wordBreak: 'break-word',
      fontSize: '11px',
    },
  },
  subscriptionDetailValue: {
    fontSize: '14px',
    fontWeight: 600,
    color: theme.evPalette.charcoal[700],
    '@media (max-width: 640px)': {
      fontSize: '12px',
    },
  },
  subscriptionDateValue: {
    fontSize: '12px',
    fontWeight: 600,
    color: theme.evPalette.charcoal[900],
    whiteSpace: 'nowrap',
    textAlign: 'right',
    '@media (max-width: 640px)': {
      whiteSpace: 'normal',
      fontSize: '11px',
      wordBreak: 'break-word',
    },
  },
  contentSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  usageSummaryContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '16px',
    alignItems: 'stretch',
    justifyContent: 'space-between',
    '@media (max-width: 640px)': {
      flexDirection: 'column',
    },
  },
  chartSection: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minHeight: '320px',
    '& > *': {
      flex: 1,
      minHeight: 0,
    },
    '@media (max-width: 640px)': {
      width: '100%',
    },
  },
  usageTableSection: {
    display: 'flex',
    flexDirection: 'column',
    flex: 0.6,
    border: `1px solid ${theme.evPalette.charcoal[400]}`,
    borderRadius: '4px',
    padding: '12px',
    backgroundColor: theme.evPalette.salt[100],
    '@media (max-width: 640px)': {
      flex: 1,
      width: '100%',
      padding: '8px',
    },
  },
  usageTableTitle: {
    color: theme.evPalette.charcoal[800],
    paddingLeft: '8px',
  },
  usageTable: {
    backgroundColor: theme.evPalette.salt[100],
    borderRadius: '4px',
    '& .myev-MuiTableCell-root': {
      border: 'none',
      padding: '8px',
    },
  },
  usageTableRow: {
    '&:nth-of-type(even)': {
      backgroundColor: theme.evPalette.charcoal[100],
    },
  },
  usageTableLabel: {
    fontSize: '14px',
    fontWeight: 400,
    color: theme.evPalette.charcoal[700],
    '@media (max-width: 640px)': {
      fontSize: '12px',
    },
  },
  usageTableValue: {
    fontSize: '14px',
    fontWeight: 500,
    color: theme.evPalette.charcoal[800],
    lineHeight: '20px',
    textAlign: 'right',
    '@media (max-width: 640px)': {
      fontSize: '12px',
    },
  },
  subscriptionIconContainer: {
    width: '100px',
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
  },
  iconStyle: {
    width: '100px',
    height: '80px',
  },
  subscriptionIcon: {
    width: '38px',
    height: '20px',
    position: 'absolute',
    left: '54px',
    top: '20px',
    backgroundColor: theme.evPalette.salt[100],
    border: `1px solid ${theme.evPalette.ocean[600]}`,
    borderRadius: '20px',
    padding: '6px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  subscriptionIconText: {
    color: theme.evPalette.ocean[600],
    fontFamily: 'Noto Sans',
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: '16px',
    letterSpacing: '0.33px',
  },
}));
